import { getUrlWithQueryParameters } from '@/app/utils/getUrlWithQueryParameters';
import { PATH } from 'constants/path';
import { GetServerSidePropsContext } from 'next';
import { enforceSafeRedirectUrl } from 'utils/enforceSafeRedirectUrl';

export default function Signin() {
  return '';
}
export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const { query } = ctx;
  enforceSafeRedirectUrl(query.redirect_url);

  return {
    redirect: {
      destination: getUrlWithQueryParameters(PATH.UNIVERSAL_LOGIN, {
        redirect_url: query.redirect_url as string,
      }),
      permanent: false,
    },
  };
}
